<template>
  <full-screen :title="t('reservations.title')" @close="router.back()">
    <reservations />
  </full-screen>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

import FullScreen from '@/components/FullScreen.vue'

import Reservations from './ReservationsList.vue'

const { t } = useI18n()
const router = useRouter()
</script>
